import React from 'react';
import styled from 'styled-components';
import { queryHistogramInfo } from '../../../../../components/KubitTooltip/globalTooltips';
import SectionHeading from '../../../../../components/SectionHeading';
import HistogramSubject from './HistogramSubject';
import HistogramBinning from './HistogramBinning';
import ThinDivider from '../../../../../components/ThinDivider';
import { borderedContent } from '../../../../../styles/shareableStyles';

const Container = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  column-gap: 8px;
  padding: 8px 16px;
  ${borderedContent};
`;

const SubjectWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
`;

const Histogram = () => {
  return (
    <>
      <SectionHeading heading="Histogram" tooltipOption={queryHistogramInfo} />
      <Container>
        <SubjectWrapper>
          <HistogramSubject />
          <ThinDivider layout="vertical" size="short" />
        </SubjectWrapper>
        <HistogramBinning />
      </Container>
    </>
  );
};

export default Histogram;
